// Stage Mail-V2 Composer (2026-07-23): MailComposerToolbar — shared composer toolbar.
//
// 2026-07-24 重构:底部仅 3 个操作 — 送信 / 添付 / AI 生成。
//   - 左侧 [送信][添付]
//   - 右侧 [AI 生成]
//   - 视觉参考 Reply Pane 的 .mv2-reply-toolbar / .mv2-ai-reply-btn
//   - 削除 草稿 / 絵文字 / リンク / 画像 / More 菜单 全部移除
//
// 设计:
//   - 受信 caller 传 onSend / canSend / sending + onAttachClick + uploadingCount
//   - AI 生成 button 本次仅视觉,不接功能

import { Paperclip, Send, Sparkles } from "lucide-react";
import type { ReactNode } from "react";

export interface MailComposerToolbarProps {
  /** 送信中(由 caller 派生 saveStatus === "saving") */
  sending: boolean;
  /** 送信按钮 disabled 判定 — 由 caller 传,通常:!to.trim() || !subject.trim() */
  canSend: boolean;
  onSend: () => void;

  /** 附件按钮 — 可选(部分外壳不需要上传附件) */
  onAttachClick?: () => void;
  /** 上传中数量(显示 アップロード中…) */
  uploadingCount?: number;
  attachmentInput?: ReactNode;
  /** 2026-07-24: AI 生成按钮点击 — 复用原本的「AI 生成」按钮(className/icon/位置不变)。 */
  onAiClick?: () => void;
}

export function MailComposerToolbar({
  sending,
  canSend,
  onSend,
  onAttachClick,
  uploadingCount,
  attachmentInput,
  onAiClick,
}: MailComposerToolbarProps) {
  const sendingDisabled = sending || !canSend;
  return (
    <div className="mv2-compose-toolbar" data-testid="mv2-compose-toolbar">
      {/* 左:送信 + 添付 */}
      <div className="mv2-compose-toolbar-left">
        <button
          type="button"
          className="mv2-compose-send"
          onClick={onSend}
          disabled={sendingDisabled}
          data-testid="mv2-compose-send"
        >
          <Send size={14} />
          <span>{sending ? "送信中…" : "送信"}</span>
        </button>
        {onAttachClick && (
          <button
            type="button"
            className="mv2-compose-iconbtn"
            onClick={onAttachClick}
            disabled={sending}
            aria-label="添付ファイル"
            title="添付ファイル"
          >
            <Paperclip size={16} />
          </button>
        )}
        {attachmentInput}
        {typeof uploadingCount === "number" && uploadingCount > 0 && (
          <span className="mv2-compose-saving">
            アップロード中… ({uploadingCount})
          </span>
        )}
      </div>

      {/* 右:AI 生成(2026-07-24: 接 onAiClick,从 MailV2Page 打开 drawer) */}
      <div className="mv2-compose-toolbar-right">
        <button
          type="button"
          className="mv2-ai-reply-btn"
          onClick={onAiClick}
          disabled={sending}
          aria-label="AI 生成"
          title="AI 生成"
        >
          <Sparkles size={14} />
          AI 生成
        </button>
      </div>
    </div>
  );
}